import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import moment from 'moment';
import { addList, editList, pwdList } from './config';
import { getAdminList, addAdmin, editAdmin, updateAdmin, deleteAdmin, updateAdminPwd } from '@/services/accountList.js';
import AccountFormModel from "@/pages/systemsettings/account/accountFormModel.vue";

/**
 * 操作类型
 * @type {{ChangePassword: string, EditUser: string, AddUser: string}}
 */
var ActionTypes = {
  // 修改用户密码
  ChangePassword: 'ChangePassword',
  // 添加用户
  AddUser: 'AddUser',
  // 编辑用户
  EditUser: 'EditUser'
};
export default {
  components: {
    AccountFormModel: AccountFormModel,
    StandardTableVue: StandardTableVue
  },
  i18n: require("../i18n-basucSettings"),
  data: function data() {
    var _this = this;
    var columns = [{
      dataIndex: 'userAccount',
      title: this.$t('account.emailAccount'),
      scopedSlots: {
        customRender: 'account'
      }
    }, {
      title: this.$t('account.name'),
      dataIndex: 'userName'
    }, {
      title: this.$t('account.state'),
      dataIndex: 'userStatus',
      scopedSlots: {
        customRender: 'state'
      }
    }, {
      title: this.$t('account.updateTime'),
      dataIndex: 'lastUpdateTime',
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    var checkPwd = function checkPwd(rule, value, callback) {
      if (value == '') {
        callback(new Error(_this.$t('account.pwdRule4')));
      } else if (value !== _this.form.pwd) {
        callback(new Error(_this.$t('account.pwdRule2')));
      } else {
        callback();
      }
    };
    var checkNewPwd = function checkNewPwd(rule, value, callback) {
      if (value == '') {
        callback(new Error(_this.$t('account.pwdRule1')));
      } else if (value !== _this.form.newPwd) {
        callback(new Error(_this.$t('account.pwdRule2')));
      } else {
        callback();
      }
    };
    var addRules = {
      account: [{
        required: true,
        message: this.$t('account.emailRule2'),
        trigger: 'blur'
      }, {
        message: this.$t('account.userLength'),
        min: 2,
        max: 60,
        trigger: 'blur'
      }],
      name: [{
        required: true,
        message: this.$t('account.nameRule'),
        trigger: 'blur'
      }, {
        min: 2,
        max: 18,
        message: this.$t('account.nameLength'),
        trigger: 'blur'
      }],
      pwd: [{
        required: true,
        message: this.$t('account.pwdRule4'),
        trigger: 'blur'
      }, {
        min: 4,
        max: 20,
        message: this.$t('account.pwdLength'),
        trigger: 'blur'
      }],
      newPwd: [{
        required: true,
        message: this.$t('account.pwdRule3'),
        trigger: 'blur'
      }, {
        min: 4,
        max: 20,
        message: this.$t('account.pwdLength')
      }],
      confirmPwd: [{
        required: true,
        message: this.$t('account.confirmPwdPlace'),
        trigger: 'blur'
      }, {
        required: true,
        validator: checkPwd,
        trigger: ['change', 'blur']
      }],
      confirmNewPwd: [{
        required: true,
        message: this.$t('account.confirmPwdPlace'),
        trigger: 'blur'
      }, {
        required: true,
        validator: checkNewPwd,
        trigger: ['change', 'blur']
      }],
      isAdmin: [{
        required: true,
        trigger: 'change'
      }]
    };
    return {
      data: [],
      // 用户列表数据
      loadingTable: false,
      //用户列表table loading
      columns: columns,
      // 用户列表列定义
      adminname: '',
      // 管理员名字
      moment: moment,
      // 日期时间库
      search: {
        // 搜索条件数据
        title: '',
        // 邮箱账号
        status: undefined // 状态
      },
      addList: addList,
      // 添加用户form 字段列表
      editList: editList,
      // 编辑用户form 字段列表
      pwdList: pwdList,
      // 修改密码form 字段列表
      form: {},
      // 添加/编辑/修改密码 表单form
      rules: {},
      // 添加/编辑/修改密码 表单 rules
      visible: false,
      // 是否显示添加/编辑/修改密码 弹窗
      title: '',
      // 添加/编辑/修改密码 弹窗标题
      addRules: addRules,
      // 添加/编辑/修改密码 弹窗标题
      checkPwd: checkPwd,
      // 校验密码方法
      formList: [],
      // 添加/编辑/修改密码 弹窗 使用的字段列表

      total: 0,
      // 用户列表数据总数
      page: 1,
      // 页码
      size: 10,
      // 数量
      currentRow: null,
      // 当前行数据
      currentAction: '',
      // 当前操作 添加用户/编辑用户/修改密码
      confirmLoading: false
    };
  },
  mounted: function mounted() {
    console.log('this', this);
    var userInfo = JSON.parse(localStorage.getItem('admin.user'));
    this.adminname = userInfo['username'];
    this.queryAdmin();
  },
  methods: {
    /**
     * 请求用户管理列表
     * @param param
     * @return {Promise<void>}
     */
    initData: function initData(param) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.loadingTable = true;
              _context.n = 1;
              return getAdminList(param);
            case 1:
              res = _context.v;
              console.log('res', res);
              try {
                if (res.data.code == 200) {
                  _this2.data = res.data.data.list;
                  _this2.total = res.data.data.total;
                }
              } finally {
                _this2.loadingTable = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * 获取用户管理列表
     */
    queryAdmin: function queryAdmin() {
      var params = {
        userifo: this.search.title,
        status: this.search.status,
        page: this.page,
        size: this.size
      };
      this.initData(params);
    },
    // 更改页码
    change: function change(_ref) {
      var current = _ref.current,
        pageSize = _ref.pageSize;
      console.log(current, pageSize);
      this.page = current;
      this.size = pageSize;
      this.queryAdmin();
    },
    /**
     * 启用/停用用户
     * @param row
     * @return {Promise<void>}
     */
    confirm: function confirm(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              console.log('row', row);
              params = {
                userid: row.id,
                status: row.userStatus === 0 ? 1 : 0 //状态 0： 正常 1:禁用 2:删除
              };
              if (!row.updateAdminLoading) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              row.updateAdminLoading = true;
              _context2.p = 2;
              _context2.n = 3;
              return updateAdmin(params);
            case 3:
              res = _context2.v;
              if (res.data.code == 200) {
                _this3.$message.success(_this3.$t('public.changeSuccessfully'));
                _this3.queryAdmin();
              }
            case 4:
              _context2.p = 4;
              row.updateAdminLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2,, 4, 5]]);
      }))();
    },
    /**
     * 启用/停用用户 取消
     */
    cancel: function cancel() {
      // this.$message.error(this.$t('switchError'));
    },
    /**
     * 删除用户
     * @param row
     * @return {Promise<void>}
     */
    confirmDelete: function confirmDelete(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                userid: row.id,
                status: 2 // 状态 0： 正常 1:禁用 2:删除
              };
              _context3.n = 1;
              return updateAdmin(params);
            case 1:
              res = _context3.v;
              if (res.data.code == 200) {
                _this4.$message.success(_this4.$t('public.deleteSuccessfully'));
                _this4.queryAdmin();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    /**
     * 删除用户 取消
     */
    cancelDelete: function cancelDelete() {},
    /**
     * 添加/编辑用户
     * @param row
     * @return {Promise<void>}
     */
    addEdit: function addEdit(row) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var newForm;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this5.rules = _this5.addRules;
              if (row) {
                _this5.currentRow = row;
                _this5.currentAction = ActionTypes.EditUser;
                _this5.formList = _this5.editList;
                _this5.title = _this5.$t('publicuse.edit');
                newForm = {
                  account: row.userAccount,
                  isAdmin: row.isAdmin,
                  name: row.userName
                };
                _this5.form = newForm;
              } else {
                _this5.currentRow = null;
                _this5.currentAction = ActionTypes.AddUser;
                _this5.formList = _this5.addList;
                _this5.title = _this5.$t('publicuse.new');
                _this5.form = {
                  account: undefined,
                  isAdmin: 0,
                  name: undefined,
                  pwd: undefined,
                  confirmPwd: undefined
                };
              }
              _this5.visible = true;
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    /**
     * 添加/编辑/修改 ok
     * @param form 表单ref
     */
    ok: function ok(form) {
      var _this6 = this;
      console.log('form', this.form);
      form.validate(function (valid) {
        if (valid) {
          var promise = null;
          if (_this6.currentAction === ActionTypes.AddUser) {
            promise = _this6.handleAddUser();
          } else if (_this6.currentAction === ActionTypes.EditUser) {
            promise = _this6.handleEditUser();
          } else if (_this6.currentAction === ActionTypes.ChangePassword) {
            promise = _this6.handleChangePassword();
          } else {
            promise = Promise.resolve();
          }
          promise.then(function () {
            _this6.visible = false;
            _this6.form = {};
            form.resetFields();
          });
        }
      });
    },
    /**
     * 添加/编辑/修改 取消
     * @param form
     */
    cancel2: function cancel2(form) {
      this.form = {};
      this.visible = false;
      form.resetFields();
    },
    /**
     * 修改用户密码
     * @param row
     * @return {Promise<void>}
     */
    changePwd: function changePwd(row) {
      this.currentAction = ActionTypes.ChangePassword;
      this.currentRow = row;
      this.rules = this.addRules;
      var pwdForm = {
        newPwd: '',
        confirmNewPwd: ''
      };
      this.rules = this.addRules;
      this.form = pwdForm;
      this.title = this.$t('account.changePwd');
      this.formList = this.pwdList;
      this.visible = true;
    },
    /**
     * 处理修改密码
     */
    handleChangePassword: function handleChangePassword() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var params, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              params = {
                id: _this7.currentRow.id,
                password: _this7.form.newPwd,
                enpassword: _this7.form.confirmNewPwd
              };
              if (!_this7.confirmLoading) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _this7.confirmLoading = true;
              _context5.p = 2;
              _context5.n = 3;
              return updateAdminPwd(_this7.currentRow.id, params);
            case 3:
              res = _context5.v;
              if (res.data.code == 200) {
                _this7.$message.success(_this7.$t('public.changeSuccessfully'));
              }
            case 4:
              _context5.p = 4;
              _this7.confirmLoading = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, null, [[2,, 4, 5]]);
      }))();
    },
    /**
     * 处理新增用户
     * @return {Promise<void>}
     */
    handleAddUser: function handleAddUser() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var params, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              params = {
                userAccount: _this8.form.account,
                userName: _this8.form.name,
                password: _this8.form.pwd,
                enpassword: _this8.form.confirmPwd,
                isAdmin: _this8.form.isAdmin
              };
              if (!_this8.confirmLoading) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              _this8.confirmLoading = true;
              _context6.p = 2;
              _context6.n = 3;
              return addAdmin(params);
            case 3:
              res = _context6.v;
              if (res.data.code == 200) {
                _this8.$message.success(_this8.$t('public.addSuccessfully'));
                _this8.queryAdmin();
              }
            case 4:
              _context6.p = 4;
              _this8.confirmLoading = false;
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, null, [[2,, 4, 5]]);
      }))();
    },
    /**
     * 处理编辑用户
     * @return {Promise<void>}
     */
    handleEditUser: function handleEditUser() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var params, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              params = {
                userName: _this9.form.name,
                isAdmin: _this9.form.isAdmin
              };
              if (!_this9.confirmLoading) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              _this9.confirmLoading = true;
              _context7.p = 2;
              _context7.n = 3;
              return editAdmin(_this9.currentRow.id, params);
            case 3:
              res = _context7.v;
              if (res.data.code == 200) {
                _this9.$message.success(_this9.$t('public.updateSuccessfully'));
                _this9.queryAdmin();
              }
            case 4:
              _context7.p = 4;
              _this9.confirmLoading = false;
              return _context7.f(4);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, null, [[2,, 4, 5]]);
      }))();
    }
  }
};